<ion-tabs>
  <ion-header [translucent]="true">
    <ion-toolbar color="primary" class="custom-toolbar">
      <ion-button slot="start" size="small" class="learn-button">
        <ion-icon name="book-outline"></ion-icon> 
        {{ 'Learn' | translate }}
      </ion-button>

      <!-- Voice Setup Button in Center -->
      <div class="voice-setup-container" slot="primary">
        <ion-button class="voice-setup-button" (click)="showVoiceSetup = !showVoiceSetup">
          <ion-icon name="mic-outline"></ion-icon>
          <span>{{ 'Voice' | translate }}</span>
        </ion-button>
      </div>

      <ion-buttons slot="end" class="action-buttons">
        <div class="language-switcher-container">
          <div class="language-switcher">
            <ion-button 
              class="lang-btn" 
              [ngClass]="{'active': currentLang === 'ta'}"
              (click)="switchLanguage('ta')"
              fill="clear">
              தமிழ்
            </ion-button>
            <ion-button 
              class="lang-btn" 
              [ngClass]="{'active': currentLang === 'en'}"
              (click)="switchLanguage('en')"
              fill="clear">
              ENG
            </ion-button>
            <div class="slider" [ngStyle]="{'transform': currentLang === 'en' ? 'translateX(calc(100% + 4px))' : 'translateX(0)'}"></div>
          </div>
        </div>

        <ion-button size="small" class="logout-btn" *ngIf="isLoggedIn" (click)="signOut()">
          {{ 'Log Out' | translate }}
          <ion-icon name="log-out-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>

    <!-- Voice Setup Modal -->
    <div *ngIf="showVoiceSetup" class="voice-setup-modal">
      <ion-card>
        <ion-card-header>
          <ion-card-title>{{ 'Voice Setup Guide' | translate }}</ion-card-title>
          <ion-button fill="clear" (click)="showVoiceSetup = false" class="close-button">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-card-header>
        <ion-card-content>
          <div class="voice-setup-content">
            <!-- Browser not supported message -->
            <div *ngIf="!isSpeechSynthesisSupported" class="unsupported-browser">
              <ion-icon name="warning-outline" class="warning-icon"></ion-icon>
              <h2>{{ 'Browser Not Supported' | translate }}</h2>
              <p>{{ 'Please use a modern browser like Chrome, Firefox, or Safari' | translate }}</p>
            </div>

            <!-- Voice installation instructions -->
            <div *ngIf="isSpeechSynthesisSupported" class="platform-instructions">
              <!-- Windows Instructions -->
              <div *ngIf="isWindows" class="instruction-set">
                <div class="platform-header">
                  <ion-icon name="logo-windows"></ion-icon>
                  <h3>Windows</h3>
                </div>
                <ol>
                  <li>
                    <span class="step-number">1</span>
                    <span class="step-path">Settings → Time & Language → Language</span>
                  </li>
                  <li>
                    <span class="step-number">2</span>
                    <span class="step-text">Click "Add a language" and search for "Tamil"</span>
                  </li>
                  <li>
                    <span class="step-number">3</span>
                    <span class="step-text">Install the Tamil language pack</span>
                  </li>
                  <li>
                    <span class="step-number">4</span>
                    <span class="step-text">Go to Settings → Ease of Access → Narrator</span>
                  </li>
                  <li>
                    <span class="step-number">5</span>
                    <span class="step-text">Under Voice, select the Tamil voice</span>
                  </li>
                </ol>
              </div>

              <!-- macOS Instructions -->
              <div *ngIf="isMac && !isIOS" class="instruction-set">
                <div class="platform-header">
                  <ion-icon name="logo-apple"></ion-icon>
                  <h3>macOS</h3>
                </div>
                <ol>
                  <li>
                    <span class="step-number">1</span>
                    <span class="step-path">System Settings → Accessibility → Spoken Content</span>
                  </li>
                  <li>
                    <span class="step-number">2</span>
                    <span class="step-text">Click "System Voice" then click <ion-icon name="information-circle-outline"></ion-icon> icon</span>
                  </li>
                  <li>
                    <span class="step-number">3</span>
                    <span class="step-text">Select "Tamil"</span>
                  </li>
                  <li>
                    <span class="step-number">4</span>
                    <span class="step-text">Download both "Vani" and "Vani (Enhanced)" voice</span>
                  </li>
                </ol>
              </div>

              <!-- iOS/iPadOS Instructions -->
              <div *ngIf="isIOS" class="instruction-set">
                <div class="platform-header">
                  <ion-icon name="logo-apple"></ion-icon>
                  <h3>iOS/iPadOS</h3>
                </div>
                <ol>
                  <li>
                    <span class="step-number">1</span>
                    <span class="step-path">Settings → Accessibility → Spoken Content</span>
                  </li>
                  <li>
                    <span class="step-number">2</span>
                    <span class="step-text">Tap "Voices" and select "Tamil"</span>
                  </li>
                  <li>
                    <span class="step-number">3</span>
                    <span class="step-text">Download both "Vani" and "Vani (Enhanced)" voice</span>
                  </li>
                </ol>
              </div>

              <!-- Android Instructions -->
              <div *ngIf="isAndroid" class="instruction-set">
                <div class="platform-header">
                  <ion-icon name="logo-android"></ion-icon>
                  <h3>Android</h3>
                </div>
                <ol>
                  <li>
                    <span class="step-number">1</span>
                    <span class="step-path">Settings → Accessibility → Talkback</span>
                  </li>
                  <li>
                    <span class="step-number">2</span>
                    <span class="step-text">Settings → Text-to-speech → Language</span>
                  </li>
                  <li>
                    <span class="step-number">3</span>
                    <span class="step-text">Select "Tamil (India)" to enable Tamil voice</span>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </ion-card-content>
      </ion-card>
    </div>
  </ion-header>
  

  <ion-footer>
    <div class="ion-text-center footer-style">
      <span>© 2025 TAMIL.MY · <a href="https://otpam.com" target="_blank" class="footer-link">OTPAM SDN BHD (1446394-V).</a> All Rights Reserved.</span>
    </div>     
  </ion-footer>
</ion-tabs>